<!--
 * @FileDescription: 售后订单列表
 * @Author: 陈文景
 * @Date: 2022-11-08 15:23:21
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <PageSkeletonTwo>
    <template slot="header-left">
      <el-select v-model="parameter.paymentMethod" clearable size="medium" placeholder="支付方式" @change="getAfterSalesOrderList">
        <el-option v-for="item in paymentMethodOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>

      <el-select v-model="parameter.status" size="medium" multiple collapse-tags filterable clearable placeholder="状态" @change="getAfterSalesOrderList">
        <el-option label="待处理" :value="0" />
        <el-option label="审核中" :value="1" />
        <el-option label="处理中" :value="2" />
        <el-option label="已拒绝" :value="3" />
        <el-option label="已完成" :value="4" />
      </el-select>

      <el-select v-model="parameter.type" size="medium" placeholder="售后类型" @change="getAfterSalesOrderList">
        <el-option label="退款单" :value="0" />
        <el-option label="补偿单" :disabled="true" :value="1" />
      </el-select>

      <el-date-picker v-model="parameter.dateTime" :clearable="false" type="datetimerange" size="medium" range-separator="~" :default-time="['00:00:00', '23:59:59']" value-format="timestamp" start-placeholder="开始时间" end-placeholder="结束时间" @change="changeDatePicker" />

      <BatchSearch :option="searchOptins" :selected="parameter.searchType" @select="selectSearchType" @search="handleSearch" @clear="clearSearchValue" />
    </template>

    <template slot="header-right">
      <el-button size="medium" @click="dataExport">自定义导出</el-button>
      <el-button size="medium" @click="addAfterSalesList">新增售后单</el-button>
    </template>

    <template slot="container">
      <el-table :data="returnOrders" v-loading="loading" style="width: 100%;">
        <el-table-column label="售后订单" fixed="left" min-width="150">
          <template v-slot="{ row }">
            <span class="returns-id" @click="() => handleAfterSalesOrder(row.returnsId)">{{ row.returnsId }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Kaka单号" min-width="150">
          <template v-slot="{ row }">
            <span class="kk-order-id">
              <span>{{ row.kkOrderId }}</span>
              <i class="el-icon-document-copy" @click="() => handleCopy(row.kkOrderId)" />
            </span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="150">
          <template v-slot="{ row }">
            {{defaultTips(formatTimeStamp(row.createDate))  }}
          </template>
        </el-table-column>
        <el-table-column label="实际退款时间" min-width="150">
          <template v-slot="{ row }">
            {{defaultTips(formatTimeStamp(row.refundTime))  }}
          </template>
        </el-table-column>
        <el-table-column label="退款金额" min-width="80">
          <template v-slot="{ row }">
            {{ defaultTips(row.refundAmount) }}
          </template>
        </el-table-column>
        <el-table-column label="售后类型" min-width="80">
          <template v-slot="{ row }">
            {{ refundType(row.type) }}
          </template>
        </el-table-column>
        <el-table-column label="支付方式" min-width="90">
          <template v-slot="{ row }">
            {{ paymentMethod(row.paymentMethod) }}
          </template>
        </el-table-column>
        <el-table-column label="邮箱/手机号" min-width="150">
          <template v-slot="{ row }">
            {{ row.showName }}
          </template>
        </el-table-column>
        <el-table-column label="创建人" min-width="150">
          <template v-slot="{ row }">
            {{ defaultTips(row.creater) }}
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="60">
          <template v-slot="{ row }">
            {{ ordersStatus(row.status) }}
          </template>
        </el-table-column>
        <el-table-column label="失败原因" min-width="150">
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="系统自动退款失败原因" placement="top">
              <div>失败原因<i class="el-icon-question" style="margin-left:5px"></i></div>
            </el-tooltip>
          </template>
          
          <template v-slot="{ row }">
            <el-tooltip v-if="row.message" class="item" effect="dark" :content="row.message" placement="top-start">
              <div slot="content" style="width:300px">{{ row.message ? row.message : '-'  }}</div>
              <div class="ellipsis2">{{ row.message ? row.message : '-'  }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="退款原因" prop="refundReason" min-width="150">
          <template v-slot="{ row }">
            <el-tooltip v-if="row.refundReason" class="item" effect="dark" :content="row.refundReason" placement="top-start">
              <div slot="content" style="width:300px">{{ refundReason(row.refundReason) }}</div>
              <div class="ellipsis2">{{ refundReason(row.refundReason) }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="审核原因" min-width="120">
          <template v-slot="{ row }">
            <el-tooltip v-if="row.reviewReason" class="item" effect="dark" :content="row.reviewReason" placement="top-start">
              <div slot="content" style="width:300px">{{ row.reviewReason ? row.reviewReason : '-'  }}</div>
              <div class="ellipsis2">{{ row.reviewReason ? row.reviewReason : '-'  }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" min-width="100">
          <template v-slot="{ row }">
            <a v-if="row.status === 1" href="javascript:;" class="process" @click="() => handleProcess(row.returnsId)">审核</a>
            <a v-else href="javascript:;" class="details" @click="() => handleDetails(row.returnsId)">查看详情</a>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template #footer-right>
      <el-pagination background :current-page="parameter.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="parameter.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="sizeChange" @current-change="currentChange" />
    </template>

    <!-- 审核对话框 -->
    <ProcessDialog ref="processDialog" @update="getAfterSalesOrderList" />

    <!-- 新增售后单对话框 -->
    <AddAfterSalesListDialog ref="addAfterSalesList" />

    <!-- 自定义导出对话框 -->
    <el-dialog title="导出" :visible.sync="visible" width="1280px" :before-close="close">
      <div class="export-box">
        <div class="not-checked">
          <div class="tips">勾选区</div>
          <el-tabs v-model="exportActiveTabPane">
            <div class="checkout-all">
              <el-checkbox :indeterminate="orderIsIndeterminate" v-model="orderCheckAll" @change="handleOrderCheckAllChange">全选</el-checkbox>
            </div>
            <el-checkbox-group v-model="checkedOrderList" @change="handleCheckedOrderListChange">
              <el-checkbox v-for="order in orders" :disabled="order.required" :label="order.name" :key="order.code" />
            </el-checkbox-group>
          </el-tabs>
        </div>

        <div class="checked">
          <div class="tips">
            已选区 <span class="text">{{ selected.length }}</span>
          </div>
          <ul id="checked-drag" class="checked-group">
            <li v-for="item in selected" :key="item.code" :data-id="item.code" class="checked-group-item">
              <span>{{ item.name }}</span>
              <i v-if="!item.required" class="el-icon-close" @click="() => removeSelectedCheckboxItem(item.name)" />
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer">
        <el-button size="medium" @click="close">取 消</el-button>
        <el-button type="primary" size="medium" @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </PageSkeletonTwo>
</template>

<script>
import API from '@/api'
import { Sortable } from 'sortablejs'
import { copy } from '@/utils/copy'
import { dateFormat } from '@/utils/date'
import BatchSearch from '@/components/BatchSearch.vue'
import ProcessDialog from './components/ProcessDialog.vue'
import { formatTimeStamp } from '@/utils/moment'
import PageSkeletonTwo from '@/components/PageSkeletonTwo.vue'
import AddAfterSalesListDialog from './components/AddAfterSalesListDialog.vue'

let parameter = {
  type: 0, // 售后类型
  searchArray: [], // 搜索关键字数组
  searchType: 0, // 搜索类型：0.KaKa订单号 1.售后订单 2.用户邮箱
  dateTime: [], // 时间日期(请求前需要删除该字段)
  orderTimeAt: undefined, // 开始时间
  orderTimeTo: undefined, // 结束时间
  paymentMethod: undefined, // 付款方式：0.余额 1.信用卡 2.Paypal
  status: [], // 0.待处理 1.审核中 2.处理中 3.已拒绝 4.已完成
  pageNumber: 1,
  pageSize: 20
}

export default {
  name: 'afterSale_after-sale',
  components: {
    BatchSearch,
    ProcessDialog,
    PageSkeletonTwo,
    AddAfterSalesListDialog
  },
  data() {
    return {
      formatTimeStamp,

      parameter: { ...parameter },

      // 支付方式下拉选项
      paymentMethodOptions: [
        { label: '余额', value: 0 },
        { label: '信用卡', value: 1 },
        { label: 'Paypal', value: 2 },
        { label: 'Airwallex', value: 3 },
        { label: 'KakaClo', value: 4 },
        { label: 'Gift card', value: 5 },
        { label: 'Credit', value: 6 },
        { label: 'Authorized', value: 7 },
        { label: '40Seas', value: 8 },
        { label: 'Payoneer', value: 9 },
      ],

      // 搜索条件
      searchOptins: [
        { label: 'KaKa订单号', value: 0 },
        { label: '售后订单', value: 1 },
        { label: '邮箱/手机号', value: 2 },
        { label: '创建人', value: 3 }
      ],

      returnOrders: [],
      total: 0,
      loading: false,
      visible: false, // 自定义导出对话框 - 是否显示对话框
      orderIsIndeterminate: false, // 全选按钮的半选中样式
      // 自定义导出对话框 - 订单信息
      orderCheckAll: false, // 是否全选
      orders: [], // 复选框数据源
      selected: [], // 所有已选项
      exportActiveTabPane: 'order', // 自定义导出对话框 - Tabs当前激活项
      checkedOrderList: [], // 当前已选项
      // 导出字段中的英文标识对应关系
      correspondence: [],
    }
  },
  computed: {
    refundType() {
      return (value) => {
        value = Number.parseInt(value)
        switch (value) {
          case 0:
            return '退款单'
          case 1:
            return '补偿单'
          default:
            return '-'
        }
      }
    },
    paymentMethod() {
      return (value) => {
        value = Number.parseInt(value)
        switch (value) {
          case 0:
            return '余额'
          case 1:
            return '信用卡'
          case 2:
            return 'Paypal'
          case 3:
            return 'Airwallex'
          case 4:
            return 'KakaClo'
          case 5:
            return 'Gift card'
          case 6:
            return 'Credit'
          case 7:
            return 'Authorized'
          case 8:
            return '40Seas'
          case 9:
            return 'Payoneer'
          default:
            return '-'
        }
      }
    },
    ordersStatus() {
      return (value) => {
        value = Number.parseInt(value)
        switch (value) {
          case 0:
            return '处理中'
          case 1:
            return '审核中'
          case 2:
            return '退款中'
          case 3:
            return '已拒绝'
          case 4:
            return '已完成'
          default:
            return '-'
        }
      }
    },
    refundReason() {
      return (value) => {
        value = Number.parseInt(value)
        switch (value) {
          case 0:
            return "Don't Want Anymore"
          case 1:
            return 'Product Selection Error/Multiple Selection'
          case 2:
            return 'Incorrect Address Information'
          case 3:
            return 'Out Of Stock'
          case 4:
            return 'Shipment Delay'
          case 5:
            return 'Other'
          default:
            return '-'
        }
      }
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  created() {
    // 动态设置日期
    this.parameter.dateTime = [new Date(dateFormat(Date.now(), 'yyyy-MM-dd')+' 00:00:00').getTime() - 29 * 24 * 3600000, new Date(dateFormat(Date.now(), 'yyyy-MM-dd')+' 23:59:59').getTime()]
    this.parameter.orderTimeAt = this.parameter.dateTime[0]
    this.parameter.orderTimeTo = this.parameter.dateTime[1]
    if (this.$route.query.status) {
      this.clearParam()
      this.parameter.status = [Number.parseInt(this.$route.query.status)]
    }
    this.getAfterSalesOrderList()
  },
  activated() {
    if (this.$route.query.status) {
      this.clearParam()
      this.parameter.status = [Number.parseInt(this.$route.query.status)]
    }
    this.getAfterSalesOrderList()
  },
  watch: {
    checkedOrderList(value) {
      this.setSelected(value, 'orders')
    },
  },
  methods: {
    /**
     * API 获取售后订单列表
     *
     * @param {Boolean} reset 是否重置分页
     */
    async getAfterSalesOrderList(reset = true) {
      try {
        if (reset) {
          this.parameter.pageNumber = 1
        }
        this.loading = true
        let query = { ...this.parameter }
        delete query.dateTime
        let { data } = await API.getAfterSalesOrderList(query)
        this.total = data.total
        this.returnOrders = data.list
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * 日期选择器的回调事件
     *
     * @param {Array} date 选中的时间数组
     */
    changeDatePicker(date) {
      if (date && date.length === 2) {
        this.parameter.orderTimeAt = date[0]
        this.parameter.orderTimeTo = date[1]
      } else {
        this.parameter.orderTimeAt = undefined
        this.parameter.orderTimeTo = undefined
      }
      this.getAfterSalesOrderList()
    },

    /**
     * 选择搜索类型的回调
     *
     * @param {String} value 当前选中的值
     */
    selectSearchType(value) {
      this.parameter.searchType = value
      if (this.parameter.searchArray.length) {
        this.getAfterSalesOrderList()
      }
    },

    /**
     * 搜索按钮触发的回调
     *
     * @param {String} value
     */
    handleSearch(value) {
      if (value) {
        this.parameter.searchArray = value.split(',').map((item) => item.trim())
      }
      this.getAfterSalesOrderList()
    },

    /**
     * 批量搜索框的清除事件的回调
     */
    clearSearchValue() {
      this.parameter.searchArray = []
      this.getAfterSalesOrderList()
    },

    // 清除参数
    clearParam() {
      this.$set(this.parameter,'paymentMethod', undefined)
      this.$set(this.parameter,'status', undefined)
      this.$set(this.parameter,'type', undefined)
      this.$set(this.parameter,'dateTime', undefined)
      this.$set(this.parameter,'searchArray', [])
    },


    /**
     * 新增售后单
     */
    addAfterSalesList() {
      this.$refs.addAfterSalesList.show()
    },

    /**
     * 复制kakaOrderId
     */
    handleCopy(text) {
      copy(text)
    },

    /**
     * 某个审核ID被点击的回调事件
     *
     * @param {Number} returnsId 当前行的订单ID
     */
    handleAfterSalesOrder(returnsId) {
      this.$router.push(`/after-sale/after-sale/after-sale-order-details?returnsId=${returnsId}`)
    },

    /**
     * 审核
     *
     * @param {Number} returnsId 当前行的订单ID
     */
    handleProcess(returnsId) {
      this.$refs.processDialog.show(returnsId)
    },

    /**
     * 查看详情
     *
     * @param {Number} returnsId 当前行的订单ID
     */
    handleDetails(returnsId) {
      this.$router.push(`/after-sale/after-sale/after-sale-order-details?returnsId=${returnsId}`)
    },

    /**
     * 每页显示数量发生改变时的回调
     *
     * @param size 每页显示数量
     */
    sizeChange(size) {
      this.parameter.pageSize = size
      this.getAfterSalesOrderList(false)
    },

    /**
     * 上一页/下一页/当前页发生改变时的回调
     *
     * @param current 当前页
     */
    currentChange(current) {
      this.parameter.pageNumber = current
      this.getAfterSalesOrderList(false)
    },
    dataExport() {
      this.visible = true
      this.drag()
      this.getPublicSelectData()
    },
    /**
     * 拖拽功能
     * 插件中文文档: https://www.itxst.com/sortablejs/neuinffi.html
     * 插件官方文档: https://github.com/SortableJS/Sortable/tree/master/plugins/MultiDrag
     */
     drag() {
      this.$nextTick(() => {
        let element = document.getElementById('checked-drag')
        if (element) {
          new Sortable(element, {
            handle: '.checked-group-item',
            draggable: '.checked-group-item',
            animation: 500,
            dataIdAttr: 'data-id'
          })
        }
      })
    },
    /**
     * API 获取可导出字段的列表
     */
     async getPublicSelectData() {
      try {
        let { data } = await API.getPublicSelectData({ type: 11, param: undefined })
        let { data: selectedFields } = await API.getExportFieldRecords(7)
        if (selectedFields) {
          this.selectedFieldsId = selectedFields.id
          selectedFields = JSON.parse(selectedFields.content)
        }
        if (data) {
          this.exportFields = data
          data.forEach((item) => {
            this.correspondence.push(item.fields)
            if (item.fields && item.fields.length) {
              this.orders = item.fields
              if (selectedFields) {
                this.checkedOrderList = [...selectedFields.orderInfo]
              } else {
                item.fields.forEach((field) => {
                  if (field.required) {
                    this.checkedOrderList.push(field.name)
                  }
                })
              }
              if (this.checkedOrderList.length === item.fields.length) {
                this.orderCheckAll = true
                this.orderIsIndeterminate = false
              }
              if (this.checkedOrderList.length > 0 && this.checkedOrderList.length < item.fields.length) {
                this.orderCheckAll = false
                this.orderIsIndeterminate = true
              }
            } else {
              this.orders = []
            }
            
          })
          this.correspondence = this.correspondence.flat()
        }
      } catch (error) {
        throw new Error(error.message)
      }
    },
    /**
     * 自定义导出对话框 - 订单信息全选按钮事件
     * @param {Boolean} value 是否全选
     */
     handleOrderCheckAllChange(value) {
      if (value) {
        this.checkedOrderList = this.orders.map((item) => item.name)
      } else {
        this.checkedOrderList = []
        this.orders.forEach((item) => {
          if (item.required) {
            this.checkedOrderList.push(item.name)
          }
        })
      }
      if (this.checkedOrderList.length && this.checkedOrderList.length < this.orders.length) {
        this.orderIsIndeterminate = true
      } else {
        this.orderIsIndeterminate = false
      }
    },
    /**
     * 自定义导出对话框 - 订单信息某个复选框被勾选的事件
     * @param {Array} value 已勾选的复选框数组
     */
     handleCheckedOrderListChange(value) {
      let checkedCount = value.length
      this.orderCheckAll = checkedCount === this.orders.length
      this.orderIsIndeterminate = checkedCount > 0 && checkedCount < this.orders.length
    },
    /**
     * 自定义导出对话框 - 商品信息全选按钮事件
     * @param {Boolean} value 是否全选
     */
     handleGoodsCheckAllChange(value) {
      if (value) {
        this.checkedGoodsList = this.goods.map((item) => item.name)
      } else {
        this.checkedGoodsList = []
        this.goods.forEach((item) => {
          if (item.required) {
            this.checkedGoodsList.push(item.name)
          }
        })
      }
      if (this.checkedGoodsList.length && this.checkedGoodsList.length < this.goods.length) {
        this.goodsIsIndeterminate = true
      } else {
        this.goodsIsIndeterminate = false
      }
    },

    /**
     * 自定义导出对话框 - 商品信息某个复选框被勾选的事件
     * @param {Array} value 已勾选的复选框数组
     */
    handleCheckedGoodsListChange(value) {
      let checkedCount = value.length
      this.goodsCheckAll = checkedCount === this.goods.length
      this.goodsIsIndeterminate = checkedCount > 0 && checkedCount < this.goods.length
    },

    /**
     * 自定义导出对话框 - 地址信息全选按钮事件
     * @param {Boolean} value 是否全选
     */
    handleAddressCheckAllChange(value) {
      if (value) {
        this.checkedAddressList = this.address.map((item) => item.name)
      } else {
        this.checkedAddressList = []
        this.goods.forEach((item) => {
          if (item.required) {
            this.checkedAddressList.push(item.name)
          }
        })
      }
      if (this.checkedAddressList.length && this.checkedAddressList.length < this.address.length) {
        this.addressIsIndeterminate = true
      } else {
        this.addressIsIndeterminate = false
      }
    },

    /**
     * 自定义导出对话框 - 地址信息某个复选框被勾选的事件
     * @param {Array} value 已勾选的复选框数组
     */
    handleCheckedAddressListChange(value) {
      let checkedCount = value.length
      this.addressCheckAll = checkedCount === this.address.length
      this.addressIsIndeterminate = checkedCount > 0 && checkedCount < this.address.length
    },

    /**
     * 自定义导出对话框 - 金额信息全选按钮事件
     * @param {Boolean} value 是否全选
     */
    handleMoneysCheckAllChange(value) {
      if (value) {
        this.checkedMoneysList = this.moneys.map((item) => item.name)
      } else {
        this.checkedMoneysList = []
        this.goods.forEach((item) => {
          if (item.required) {
            this.checkedMoneysList.push(item.name)
          }
        })
      }
      if (this.checkedMoneysList.length && this.checkedMoneysList.length < this.moneys.length) {
        this.moneysIsIndeterminate = true
      } else {
        this.moneysIsIndeterminate = false
      }
    },

    /**
     * 自定义导出对话框 - 金额信息某个复选框被勾选的事件
     * @param {Array} value 已勾选的复选框数组
     */
    handleCheckedMoneysListChange(value) {
      let checkedCount = value.length
      this.moneysCheckAll = checkedCount === this.moneys.length
      this.moneysIsIndeterminate = checkedCount > 0 && checkedCount < this.moneys.length
    },

    /**
     * 自定义导出对话框 - 设置已勾选项
     * @param {Array} value 已勾选的复选框数组
     * @param {String} original 可选项数组
     */
    setSelected(value, original) {
      let selected = []
      let unchecked = []
      this[original].forEach((item) => {
        if (value.includes(item.name)) {
          selected.push(item.name)
        } else {
          unchecked.push(item.name)
        }
      })
      unchecked.forEach((item) => {
        this.selected.forEach((inside, index) => {
          if (item === inside.name) {
            this.selected.splice(index, 1)
          }
        })
      })
      this.correspondence.forEach((item) => {
        if (selected.includes(item.name)) {
          this.selected = Array.from(new Set([...this.selected, item]))
        }
      })
    },

    /**
     * 自定义导出对话框 - 删除某个已选的复选框
     * @param {String} value 当前删除的复选框的值
     */
    removeSelectedCheckboxItem(value) {
      if (this.checkedOrderList.includes(value)) {
        this.checkedOrderList = this.checkedOrderList.filter((item) => item !== value)
        this.handleCheckedOrderListChange(this.checkedOrderList)
      }
      if (this.checkedGoodsList.includes(value)) {
        this.checkedGoodsList = this.checkedGoodsList.filter((item) => item !== value)
        this.handleCheckedGoodsListChange(this.checkedGoodsList)
      }
      if (this.checkedAddressList.includes(value)) {
        this.checkedAddressList = this.checkedAddressList.filter((item) => item !== value)
        this.handleCheckedAddressListChange(this.checkedAddressList)
      }
      if (this.checkedMoneysList.includes(value)) {
        this.checkedMoneysList = this.checkedMoneysList.filter((item) => item !== value)
        this.handleCheckedMoneysListChange(this.checkedMoneysList)
      }
      this.selected = this.selected.filter((item) => item.name !== value)
    },

    /**
     * 自定义导出 - 对话框保存按钮的事件
     */
    save() {
      if (this.selected.length === 0) {
        this.$message.warning('请选择需要导出的字段!')
        return
      }

      let ul = document.getElementById('checked-drag')
      let selected = []
      Array.from(ul.children).forEach((li) => {
        selected.push(li.getAttribute('data-id'))
      })

      const params = {
        fileType: 2,
        taskType: 22,
        condition: JSON.stringify({
          searchContent: this.parameter,
          sortFields: [...selected]
        })
      }

      let obj = {
        orderInfo: [], // 订单信息
      }

      this.exportFields.forEach((item) => {
        if (item.code === 'order_info') {
          item.fields.forEach((field) => {
            if (selected.includes(field.code)) {
              obj.orderInfo.push(field.name)
            }
          })
        }
      })

      API.setExportFieldRecords({ id: this.selectedFieldsId ? this.selectedFieldsId : undefined, type: 7, content: JSON.stringify(obj) })
        .then(() => {})
        .catch(() => {})

      API.dashboardImportExportFile(params)
        .then(() => {
          this.close()
          this.$message.success('操作成功，请到导入导出管理查看')
        })
        .catch(() => {
          this.$message.error('导出失败，请重新操作')
        })
    },

    /**
     * 自定义导出 - 对话框关闭的事件
     */
    close() {
      this.visible = false
      this.clear()
    },

    /**
     * 自定义导出 - 负责清除数据方法
     */
    clear() {
      this.correspondence = []
      this.orderCheckAll = false
      this.checkedOrderList = []
      this.orderIsIndeterminate = false
      this.selected = []
    },
    columnConfigureSubmit(column) {
      this.showColumns = column
      this.columnInfo.content = JSON.stringify(column)
      this.changeShowColumns(column)
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  outline: none;
  &.details {
    color: #99c41c;
  }
  &.process {
    color: #eb5757;
  }
}

.returns-id {
  color: #99c41c;
  cursor: pointer;
}

.kk-order-id {
  display: inline-block;
  width: 100%;
  &:hover {
    i {
      display: inline-block;
    }
  }
  i {
    display: none;
    color: #99c41c;
    margin-left: 5px;
    cursor: pointer;
  }
}

.footer {
  padding: 0 15px 15px 15px;
  text-align: end;
  background-color: #fff;
}
.export-box {
    display: flex;
    border-radius: 4px;
    border: 1px solid #e9e9e9;
    .not-checked,
    .checked {
      padding: 10px;
      .tips {
        line-height: 18px;
        margin-bottom: 10px;
        .text {
          color: #99c41c;
          font-weight: 700;
        }
      }
    }

    .not-checked {
      flex: 9;
      border-right: 1px solid #e9e9e9;
      /deep/.el-tabs__content {
        .el-tab-pane {
          overflow: auto;
        }
      }
      .checkout-all {
        margin-bottom: 10px;
      }
      .el-checkbox-group {
        .el-checkbox {
          width: 30%;
          margin-right: 22px !important;
          margin-bottom: 6px !important;
        }
      }
    }

    .checked {
      flex: 3;
      .checked-group {
        width: 100%;
        min-height: 280px;
        max-height: 480px;
        height: calc(100% - 28px);
        overflow-y: auto;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        .checked-group-item {
          display: flex;
          width: 100%;
          line-height: 28px;
          padding: 5px 8px;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #dcdfe6;
          user-select: none;
          cursor: move;
          span {
            max-width: 258px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          i {
            width: 25px;
            height: 25px;
            line-height: 25px;
            text-align: center;
            font-size: 14px;
            cursor: pointer;
            &:hover {
              color: #f56c6c;
            }
          }
        }
      }
    }
  }
</style>
